// config.js is created by the build script from the runtim environment variables and is loaded in public/index.html
// There is no other way to inject environment variables straight before run-time in an application seved by nginx or apache


export const {otherApis,api,baseUrl,loginApi} = window['runtimeConfig']
export const Revision="3.4"
